/* eslint-disable @next/next/no-img-element */
import clsx from 'clsx';
import { FC } from 'react';

interface Props {
  loaderColor?: 'black' | 'white';
}

const CustomLoader: FC<Props> = ({ loaderColor = 'white' }) => {
  return (
    <div
      className={clsx(
        'fixed inset-0 flex flex-col items-center justify-center z-[9999]',
        'bg-black/40 backdrop-blur-md',
      )}
      style={{
        WebkitBackdropFilter: 'blur(20px)',
        backdropFilter: 'blur(20px)',
        backgroundColor: 'rgba(0,0,0,0.4)',
      }}
    >
      {loaderColor === 'black' ? (
        <img
          src='/Book_2_Black_Loader.gif'
          className='max-w-[80px] md:max-w-[170px] py-24'
          alt='Loading'
        />
      ) : (
        <img
          src='/Book_2_White_Loader.gif'
          className='max-w-[80px] md:max-w-[170px] '
          alt='Loading'
        />
      )}
      <div className='text-center text-base md:text-lg px-10 md:px-0 text-gray-300'>
        Please wait... We're getting things ready for you!
      </div>
    </div>
  );
};

export default CustomLoader;
